import { render } from "./CsBracketPage.vue?vue&type=template&id=fca7e41e&scoped=true"
import script from "./CsBracketPage.vue?vue&type=script&lang=js"
export * from "./CsBracketPage.vue?vue&type=script&lang=js"

import "./CsBracketPage.vue?vue&type=style&index=0&id=fca7e41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca7e41e"]])

export default __exports__